import { Component } from "react";
import { Dropdown } from 'react-bootstrap';

const clusters = [
    { name: "Global Region", domain: ["localhost", "www", "dev", "staging", ""], url: "https://www.tuner4tronic.com" },
    { name: "Asia Region", domain: ["apac"], url: "https://apac.tuner4tronic.com" },
];

export class ClusterSwitch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: clusters[0]
        };
    }

    componentDidMount() {
        const subdomain = this.extractSubdomain();
        const matchedCluster = this.findClusterBySubdomain(subdomain);

        if (matchedCluster) {
            console.info("Current subdomain:", subdomain);
            console.info("Detected cluster:", matchedCluster.url);
            this.setState({ selected: matchedCluster });
        }
    }

    extractSubdomain = () => {
        const hostname = window.location.hostname;
        const parts = hostname.split(".");

        // Return the first part (subdomain) or empty string if it's just a domain
        return parts[0];
    };

    findClusterBySubdomain = (subdomain) => {
        return clusters.find(cluster => cluster.domain.includes(subdomain)) || clusters[0];
    };

    handleClusterChange = (url) => {
        console.info("Selected cluster URL:", url);
        const selectedCluster = clusters.find(cluster => cluster.url === url);
        if (selectedCluster && selectedCluster.url !== this.state.selected.url) {
            window.location.href = selectedCluster.url;
        }
    };

    render() {
        return (
            <Dropdown style={{'display': 'inline-block'}}>
                <Dropdown.Toggle variant="secondary">{this.state.selected.name}</Dropdown.Toggle>
                <Dropdown.Menu>
                    {clusters.map((cluster) => (
                        <Dropdown.Item key={cluster.url} href={cluster.url}>
                            {cluster.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}
